import { render, staticRenderFns } from "./EditEducation.vue?vue&type=template&id=2eb73b3c&"
import script from "./EditEducation.vue?vue&type=script&lang=js&"
export * from "./EditEducation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports